import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AuthService} from "../../_services/auth.service";
import {ContentService} from "../../_services/content.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ViewGuideComponent} from "../written-guides/view-guide/view-guide.component";
import {User} from "../../_types/user";
import {VideoGuide} from "../../_types/content";
import {SnackbarService} from "../../_services/snackbar.service";

@Component({
    selector: 'app-videoguides',
    templateUrl: './videoguides.component.html',
    styleUrl: './videoguides.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VideoguidesComponent {
    user!: User;
    trainingCentre: VideoGuide[] = []
    loading: boolean = true;
    loadFailed: boolean = false;
    isRaaTraining: boolean = false;
    private viewedVideoIds: Set<number> = new Set<number>();

    constructor(private authService: AuthService,
                private contentService: ContentService,
                private sanitizer: DomSanitizer,
                public dialog: MatDialog,
                private snackbarService: SnackbarService) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.authService.refreshUser();
        this.authService.getDynamicSettings().then((r): void => {
            this.isRaaTraining = r.is_raa;
            this.contentService.videoGuides({
                training_center_type: this.user?.role?.role_type,
                role: this.user?.role?.name,
                is_raa_training: this.isRaaTraining
            }).subscribe({
                next: r => {
                    this.loading = false;
                    this.trainingCentre = r;
                }, error: error => {
                    this.loadFailed = true;
                    this.loading = false;
                    this.snackbarService.openSnackBar(error, 'error');
                    console.error(error)
                }
            });

        });
    }

    safeUrl(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    recordVideoView(resource: VideoGuide): void {
        // Record once per video per visit; tracking must never interrupt
        // playback, so failures (e.g. content blockers) are ignored.
        if (this.viewedVideoIds.has(resource.id)) {
            return;
        }
        this.viewedVideoIds.add(resource.id);
        this.contentService.recordTrainingVideoView(resource).subscribe({
            error: (): void => {
            }
        });
    }

    openGuide(guide: VideoGuide): void {
        this.authService.refreshUser();
        guide.isVideo = true;
        const dialogRef: MatDialogRef<ViewGuideComponent> = this.dialog.open(ViewGuideComponent, {
            data: guide,
            panelClass: 'fullWidthWindow',
        });
    }

    getIndex(VideoGuide: VideoGuide): number {
        return (this.trainingCentre.findIndex((x: VideoGuide): boolean => x.id === VideoGuide.id) + 1);
    }

}
